import React from 'react';

//import css
import './WeWorkedWith.css';

const WeWorkedWith = props => {
  return (
    <div>
      <div key="1" className="www_wrpr mobile_hide">
        <p className="hdr bf">Companies We’ve Worked With</p>
        <div className="brnds_wrpr">
          {props.companies.lines.map((line, idx) => {
            return (
              <div className="df line" key={idx}>
                {line.map((item, idx) => {
                  return <div key={idx} className={`df item ${item.class}`} />;
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div key="2" className="www_wrpr mobile_only">
        <p className="hdr bf">Companies We’ve Worked With</p>
        <div className="brnds_wrpr" />
      </div>
    </div>
  );
};

export default WeWorkedWith;



// WEBPACK FOOTER //
// ./src/components/we-worked-with/WeWorkedWith.js